<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content position-relative" id="pdfDom" :class="loadingPdf ? 'pdf-width' : ''">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :allow-edit="false"
                                                              $_em-custom-vuex-mixin_configs="sithMesNcrProcessTaskProcessVoConfigs"
                                                              query-api="typeProcess"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete"
                                      :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      sync-value-change
                                      :config="config">
                </WorkflowTaskComplete>
            </div>

            <em-button type="downloadFile" @click="savePdf"
                       class="btn btn-outline-primary btn-sm position-absolute top right mt-1 mr-1"
                       style="z-index: 900"
                       v-if="!loadingPdf"></em-button>
        </section>
    </div>
</template>
<script>
// Author Liang Gangqiang
// Date 2021-04-26 11:06:52

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";
import {_causedByOptions} from "@/views/sithMes/quality/NCR/stuff/causedByOption";

export default {
    name: "sithMesNcrProcessTaskWorkflowTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins],
    data() {
        return {
            htmlTitle: '导出PDF',
            loadingPdf: false
        }
    },
    methods: {
        savePdf() {
            this.loadingPdf = true;
            setTimeout(() => this.getPdf('#pdfDom'), 2000);
            setTimeout(() => this.loadingPdf = false, 5000);
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_emWorkflowTaskMixin_callbackApi() {
            return process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesNcrProcessTask/complete-feedback";
        },
        config() {
            return {
                'task_ncr_init': {
                    name: 'NCR信息完善',
                    variables: [
                        {
                            label: '责任确认',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '供应商责任'},
                                {value: 2, text: 'SITH责任'},
                                {value: 3, text: '内部流转'},
                                {value: 4, text: '实际关闭'},
                                {value: 5, text: '可记录NCR'},
                                {value: 6, text: '体外NCR信息详情'},
                            ]
                        },
                        {
                            label: 'NCR描述',
                            name: 'ncrDescription',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true
                        },
                        {
                            label: 'NCR Comments',
                            name: 'NCR_Comments',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                            require: true
                        },
                        {
                            label: 'Causes by',
                            name: 'causedBy',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: _causedByOptions(),
                            initData: true,
                            require: true
                        },
                        {
                            label: 'NCR风险等级',
                            name: 'ncr_risk_level',
                            type: this.VALUE_TYPE.SELECT,
                            options: [
                                {value: 1, text: '低'},
                                {value: 2, text: '高'}
                            ],
                            require: true
                        },
                        {
                            label: '数量',
                            name: 'ncr_count',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                            require: true
                        }
                    ],
                    withAttachment: true,
                    addVariableByApprove: approve => {
                        let temp = {
                            4: 'C0', 5: 'C3'
                        }
                        if (approve === 4 || approve === 5) {
                            return {name: 'solutionCode', value: temp[approve]};
                        }
                    },
                    copyToData: true,
                    userSelectMap: {
                        '*': [
                            {
                                name: 'task_candidateUsers',
                                allowMulti: true,
                                require: true
                            },
                            {
                                name: 'email_cc',
                                labelWithout: 'Email Cc',
                                allowMulti: true
                            }
                        ],
                        2: [
                            {
                                name: 'task_tc_examine_candidateUsers',
                                allowMulti: true,
                                require: true
                            },
                            {
                                name: 'email_cc',
                                labelWithout: 'Email Cc',
                                allowMulti: true
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task_purchase_examine',
                        2: 'task_tc_examine',
                        3: 'task_ncr_init',
                        4: 'task_actual_off',
                        5: 'task_tc_solution',
                        6: 'task_ncr_detail_input'
                    }
                },
                'task_ncr_detail_input': {
                    name: '体外NCR信息详情',
                    variables: [
                        {
                            label: '工程号',
                            name: 'projectCode',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                        },
                        {
                            repeat: true,
                            labelWithName: {
                                'nameOfParts': '零部件名称',
                                'pictureNo': '图号',
                                'materialNo': '物料号',
                                'bgCidNo': 'BG/CID号',
                                'material': '材料',
                                'operationNo': '工序序号',
                                'productionType': '产品种类',
                                'equipmentCode': '设备编号',
                                'designer': '设计者',
                                'craftsman': '工艺员',
                                'operator': '操作者',
                                'purchaseNo': '采购单号',
                                'purchaseItemNo': '采购Item No',
                                'purchaser': '采购员',
                                'reason': '原因',
                            },
                            type: this.VALUE_TYPE.INPUT,
                        },
                        {
                            label: '供方',
                            name: 'supplier',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                        },
                        {
                            label: '重复性',
                            name: 'happenType',
                            type: this.VALUE_TYPE.SELECT,
                            options: ['第一次发生', '重复性发生']
                        }
                    ],
                    withAttachment: true,
                    userSelectMap: {
                        '*': [{
                            name: 'task_tc_examine_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: 'task_tc_examine'
                },
                'task_purchase_examine': {
                    name: '采购批复',
                    variables: [
                        {
                            label: '反馈意见',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '申请让步接受'},
                                {value: 2, text: 'SITH修复'},
                                {value: 3, text: '供应商换货或供应商自行修复'},
                                {value: 4, text: '供应商退货'},
                                {value: 5, text: '信息补充'},
                            ]
                        }
                    ],
                    withAttachment: true,
                    addVariableByApprove: approve => {
                        let tempMap = {
                            1: 'A1',
                            2: 'A2',
                            3: 'A3',
                            4: 'A4',
                            5: 'C4',
                        }
                        return {name: 'solutionCode', value: tempMap[approve]};
                    },
                    copyToData: true,
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        2: [{
                            name: 'task_tc_examine_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_tc_confirm_compromise',
                        2: 'task_tc_confirm_repair',
                        '3,4': 'task_technical_off',
                        5: 'task_ncr_init'
                    }
                },
                'task_tc_confirm_compromise': {
                    name: '技术批复是否可让步',
                    approveLabel: '是否可让步',
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    approveToNextTask: {
                        1: 'task_technical_off',
                        2: 'task_purchase_examine'
                    }
                },
                'task_tc_confirm_repair': {
                    tag: {},
                    name: '技术判断是否可修复',
                    variables: [
                        {
                            label: '是否可修复',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '可修复'},
                                {value: 2, text: '不可修复，转-供应商换货或供应商自行修复'}
                            ],
                            changeTag: val => {
                                return this.buildTag('repair', val === 1);
                            }
                        },
                        {
                            needTag: 'repair',
                            label: 'Group No.',
                            name: 'group_num',
                            type: this.VALUE_TYPE.INPUT,
                            require: true
                        },
                        {
                            needTag: 'repair',
                            label: 'Material No.',
                            name: 'material_num',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true
                        },
                        {
                            needTag: 'repair',
                            label: 'Material Quantity',
                            name: 'material_qua',
                            type: this.VALUE_TYPE.INPUT
                        },
                        {
                            needTag: 'repair',
                            label: '工程师意见',
                            name: 'TC_Comment',
                            type: this.VALUE_TYPE.INPUT,
                            require: true
                        }
                    ],
                    withAttachment: true,
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    addVariableByApprove: approve => {
                        if (approve === 2) {
                            return {name: 'solutionCode', value: 'A3'};
                        }else if (approve === 1) {
                            return {name: 'solutionCode', value: 'A2'};
                        }
                    },
                    copyToData: true,
                    approveToNextTask: {
                        1: 'task_tc_solution',
                        2: 'task_technical_off'
                    }
                },
                'task_tc_examine': {
                    name: '技术批复及编写工艺',
                    tag: {},
                    variables: [
                        {
                            label: 'NCR 处理方式',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '让步接受'},
                                {value: 2, text: 'SITH修复'},
                                {value: 3, text: '报废-SITH自制'},
                                {value: 4, text: '报废-采购成品'},
                                {value: 5, text: '信息补充'},
                                // {value: 6, text: '实际关闭'},
                            ],
                            changeTag: val => {
                                return this.buildTag('repair', val === 2 || val === 3 || val === 4);
                            }
                        },
                        {
                            needTag: 'repair',
                            label: 'Group No.',
                            name: 'group_num',
                            type: this.VALUE_TYPE.INPUT,
                            require: true
                        },
                        {
                            needTag: 'repair',
                            label: 'Material No.',
                            name: 'material_num',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true
                        },
                        {
                            needTag: 'repair',
                            label: 'Material Quantity',
                            name: 'material_qua',
                            type: this.VALUE_TYPE.INPUT
                        },
                        {
                            label: '工程师意见',
                            name: 'TC_Comment',
                            type: this.VALUE_TYPE.INPUT,
                            require: true
                        }
                    ],
                    withAttachment: true,
                    addVariableByApprove: approve => {
                        let tempMap = {
                            1: 'B1',
                            2: 'B2',
                            3: 'B3',
                            4: 'B4',
                            5: 'C1',
                            6: 'C2'
                        }
                        return {name: 'solutionCode', value: tempMap[approve]};
                    },
                    copyToData: true,
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    approveToNextTask: {
                        '1,6': 'task_technical_off',
                        '2,3,4': 'task_tc_solution',
                        5: 'task_ncr_init',
                    }
                },
                'task_tc_solution': {
                    name: '判断是否需要特殊工艺',
                    tag: {},
                    variables: [
                        {
                            label: '特殊工艺',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '需要'},
                                {value: 2, text: '不需要'}
                            ],
                            changeTag: val => {
                                return this.buildTag('specialSolution', val === 1);
                            }
                        },
                        {
                            needTag: 'specialSolution',
                            label: '热处理',
                            name: 'solution_hot',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.FLOW,
                        },
                        {
                            needTag: 'specialSolution',
                            label: '焊接',
                            name: 'solution_welding',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.FLOW,
                        },
                        {
                            needTag: 'specialSolution',
                            label: 'CNC编程',
                            name: 'solution_cnc',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.FLOW,
                        },
                        {
                            needTag: 'mark',
                            label: 'Group No.',
                            name: 'group_num',
                            type: this.VALUE_TYPE.INPUT,
                            require: true
                        },
                        {
                            needTag: 'mark',
                            label: 'Material No.',
                            name: 'material_num',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true
                        },
                        {
                            needTag: 'mark',
                            label: 'Material Quantity',
                            name: 'material_qua',
                            type: this.VALUE_TYPE.INPUT
                        },
                        {
                            label: '工程师意见',
                            name: 'tc_comment',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.FLOW
                        }
                    ],
                    changeTag: (businessData) => {
                        return this.buildTag('mark', businessData.solutionCode === 'C3');
                    },
                    withAttachment: true,
                    userSelectMap: {
                        1: [{
                            name: 'task_next_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        2: [
                            {
                                name: 'task_candidateUsers',
                                label: '内部审核',
                                allowMulti: true,
                                require: true
                            },
                            {
                                name: 'task_next_candidateUsers',
                                label: 'PP',
                                allowMulti: true,
                                require: true
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task_special_solution',
                        2: 'task_tc_confirm_solution'
                    }
                },
                'task_special_solution': {
                    name: '特殊工艺',
                    withAttachmentNotNull: true,
                    approveToNextTask: 'task_tc_solution'
                },
                'task_tc_confirm_solution': {
                    name: '内部审核',
                    approveLabel: '是否通过',
                    setApproveBeforeSubmit: approve => {
                        if (approve === 2) {
                            if (this.taskLocalVariables.solutionCode && this.taskLocalVariables.solutionCode === 'A2') {
                                return 3;
                            }
                        }
                        return approve;
                    },
                    withComment: true,
                    approveToNextTask: {
                        1: 'task_pp_order_code',
                        2: 'task_tc_examine',
                        3: 'task_tc_confirm_repair'
                    }
                },
                'task_pp_order_code': {
                    name: 'PP：生成生产订单号',
                    variables: [
                        {
                            label: '生产订单号',
                            name: 'ppHeaderId',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        }
                    ],
                    withComment: true,
                    withAttachment: true,
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    approveToNextTask: 'task_technical_off'
                },
                'task_technical_off': {
                    name: 'NCR技术关闭',
                    variables: [
                        {
                            label: 'NCR技术关闭',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 10, text: '技术关闭'},
                                {
                                    label: '回溯', options: [
                                        {value: 3, text: 'NCR信息完善'},
                                        {value: 6, text: '采购批复'},
                                        {value: 5, text: '技术判断是否让步'},
                                        {value: 4, text: '技术判断是否修复'},
                                        {value: 2, text: '技术批复及编写工艺'},
                                        {value: 7, text: '工程师编写工艺'},
                                        {value: 1, text: 'PP生成生产订单号'},
                                    ]
                                }
                            ]
                        },
                    ],
                    withComment: true,
                    setApproveBeforeSubmit: approve => {
                        if (approve === 10) {
                            if (this.taskLocalVariables.hasOwnProperty('solutionCode')) {
                                let solutionCode = this.taskLocalVariables.solutionCode;
                                switch (solutionCode) {
                                    case 'A1':
                                    case 'A3':
                                    case 'A4':
                                    case 'B1':
                                    case 'C2':
                                        return 11;
                                    case 'A2':
                                    case 'B2':
                                    case 'B3':
                                    case 'B4':
                                    case 'C3':
                                        return 12;
                                    default:
                                        return 13;
                                }
                            }
                        }
                        return approve;
                    },
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        1: [{
                            name: 'task_next_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        '2,4': [{
                            name: 'task_tc_examine_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        13: [{
                            name: 'task_next_candidateUsers',
                            label: '财务',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    postByApprove: (approve) => {
                        let off = approve > 10;
                        return {
                            url: process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesNcrProcessTask/technical/off",
                            data: {
                                id: this.$_emWorkflowTaskMixin_businessKey,
                                technicalOff: off
                            }
                        };
                    },
                    approveToNextTask: {
                        1: 'task_pp_order_code',
                        2: 'task_tc_examine',
                        3: 'task_ncr_init',
                        4: 'task_tc_confirm_repair',
                        5: 'task_tc_confirm_compromise',
                        6: 'task_purchase_examine',
                        7: 'task_tc_solution',
                        11: 'task_actual_off',
                        12: 'task_pp_teco',
                        13: 'task_waiting_finish'
                    }
                },
                'task_pp_teco': {
                    name: 'PP：TECO',
                    approveLabel: '是否TECO',
                    userSelectMap: {
                        '*': [{
                            name: 'task_next_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        2: [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_cal_ncc',
                        2: 'task_technical_off'
                    }
                },
                'task_cal_ncc': {
                    name: '财务：计算NCC',
                    variables: [
                        {
                            label: 'NCC',
                            name: 'ncc',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        },
                        {
                            label: 'NCR额外成本',
                            name: 'NCR_extra_cost',
                            type: this.VALUE_TYPE.INPUT
                        }
                    ],
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    approveToNextTask: 'task_actual_off'
                },
                'task_waiting_finish': {
                    name: '等待工单完成',
                    userSelectMap: {
                        '*': [{
                            name: 'task_next_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                    },
                    approveToNextTask: 'task_cal_ncc'
                },
                'task_actual_off': {
                    name: 'NCR实际关闭',
                    variables: [
                        {
                            label: 'NCR实际关闭',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 10, text: '实际关闭'},
                                {
                                    label: '回溯', options: [
                                        {value: 2, text: '财务计算NCC'},
                                        {value: 1, text: 'NCR技术关闭'},
                                    ]
                                }
                            ]
                        },
                    ],
                    withComment: true,
                    setApproveBeforeSubmit: approve => {
                        if (approve === 10) {
                            if (this.taskLocalVariables.hasOwnProperty('solutionCode')) {
                                let solutionCode = this.taskLocalVariables.solutionCode;
                                switch (solutionCode) {
                                    case 'A1':
                                    case 'A3':
                                    case 'A4':
                                    case 'B1':
                                    case 'C0':
                                    case 'C2':
                                    case 'C3':
                                        return 11;
                                    case 'A2':
                                        return 12;
                                    case 'B2':
                                    case 'B3':
                                    case 'B4':
                                        return 14;
                                }
                            }
                        }
                        return approve;
                    },
                    setApproveByBusinessData: (businessData, approve) => {
                        if (!businessData.need8dAnalysis && approve === 14) {
                            return 15;
                        }
                        return approve;
                    },
                    userSelectMap: {
                        '*': [{
                            name: 'task_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        2: [{
                            name: 'task_next_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        '11,13,15': []
                    },
                    postByApprove: (approve) => {
                        let off = approve > 10;
                        return {
                            url: process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesNcrProcessTask/actual/off",
                            data: {
                                id: this.$_emWorkflowTaskMixin_businessKey,
                                actualOff: off
                            }
                        };
                    },
                    approveToNextTask: {
                        1: 'task_technical_off',
                        2: 'task_cal_ncc',
                        '11,13': 'task_end',
                        12: 'task_supplier_ncc',
                        14: 'task_8d_analysis'
                    }
                },
                'task_supplier_ncc': {
                    name: '向供应商索赔NCC',
                    variables: [
                        {
                            repeat: true,
                            labelWithName: {
                                'recoverNcc': '追回索赔金额',
                                'recoverNccRemark': '索赔项备注'
                            },
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true
                        }
                    ],
                    approveToNextTask: 'task_end'
                },
                'task_8d_analysis': {
                    name: '质量：发起8D分析',
                    withAttachmentNotNull: true,
                    approveToNextTask: 'task_end'
                },
                'task_end': {
                    name: '无'
                }
            }
        }
    },
}
</script>
<style scoped>
.pdf-width {
    width: 900px;
}
</style>